import store from "../../redux/store.js";
import { API_URL } from "./env.js";

const FLYOUT_API_URL = `${API_URL}/flyouts`;
const PLAN_API_URL = `${API_URL}/plan`;
const ALL_PLANS_API_URL = `${API_URL}/plans`;

export async function getFlyouts() {
    const sessionToken = store.getState().user.sessionToken;
    return fetch(FLYOUT_API_URL, {
        headers: {
            'Authorization': `Bearer ${sessionToken}`
        }
    })
        .then(response => response.json())
        .then(data => data)
        .catch(error => {
            console.error('Error fetching flyouts:', error);
            throw error;
        });
}

export async function createFlyout(flyoutData) {
    return fetch(FLYOUT_API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(flyoutData)
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .catch(error => {
            console.error('Error creating flyout:', error);
            throw error;
        });
}

export async function updateFlyout(flyoutData) {
    return fetch(`${FLYOUT_API_URL}/${flyoutData.flyoutId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(flyoutData)
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .catch(error => {
            console.error('Error updating flyout:', error);
            throw error;
        });
}

export async function deleteFlyout(flyoutId) {
    return fetch(`${FLYOUT_API_URL}/${flyoutId}`, {
        method: 'DELETE'
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
        });
}

function generateEmptyPlan(flyout, plane) {
    return {
        flyoutId: flyout.flyoutId,
        plane: {
            reg: plane.reg,
            type: plane.type,
            PoB: plane.PoB
        },
        days: flyout.days.map(day => {
            return {
                name: day.name,
                startPoint: day.startPoint,
                endPoint: day.endPoint,
                legs: []
            };
        }),
    }
}

export async function getPlan(flyout) {
    const sessionToken = store.getState().user.sessionToken;    
    return fetch(`${PLAN_API_URL}/${flyout.flyoutId}`, {
        headers: {
            'Authorization': `Bearer ${sessionToken}`
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text().then(text => text ? JSON.parse(text) : {});
    })
    .catch(error => {
        console.error('Error fetching plan:', error);
        throw error;
    });
}

export async function getAllPlans(flyout) {
    const sessionToken = store.getState().user.sessionToken;
    return fetch(`${ALL_PLANS_API_URL}/${flyout.flyoutId}`, {
        headers: {
            'Authorization': `Bearer ${sessionToken}`
        }
    })
    .then(response => response.json())
    .catch(error => {
        console.error('Error fetching all plans:', error);
        throw error;
    });
}

export async function createPlan(flyout, plane) {
    const plan = generateEmptyPlan(flyout, plane);
    const sessionToken = store.getState().user.sessionToken;
    return fetch(PLAN_API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`
        },
        body: JSON.stringify(plan)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .catch(error => {
        console.error('Error creating plan:', error);
        throw error;
    });
}

export async function updatePlan(flyout, plan) {
    const sessionToken = store.getState().user.sessionToken;
    return fetch(`${PLAN_API_URL}/${flyout.flyoutId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`
        },
        body: JSON.stringify(plan)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .catch(error => {
        console.error('Error saving plan:', error);
        throw error;
    });
}

export async function deletePlan(flyout) {
    const sessionToken = store.getState().user.sessionToken;
    return fetch(`${PLAN_API_URL}/${flyout.flyoutId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${sessionToken}`
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .catch(error => {
        console.error('Error deleting plan:', error);
        throw error;
    });
}